<script setup>
// 右侧「AI EFFECTS」推广栏（与 design 一致）。交叉引流到站点 AI 效果。
// 4 个卡片为线上 CDN 真实效果，随机抽取且每次切页重新随机。
import { useRandomEffects } from "@/composables/useRandomEffects";

const fx = useRandomEffects(4);
const EFFECTS_URL = "/ai/effects/"; // 站点 AI 效果入口
</script>

<template>
  <div class="fxrail">
    <div class="fxrail-in">
      <div class="eyebrow">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 3l1.8 4.4L18 9l-4.2 1.6L12 15l-1.8-4.4L6 9l4.2-1.6z" />
        </svg>AI EFFECTS
      </div>
      <h3>Make your photo go viral</h3>
      <p>One tap turns any image into a trending AI Effect — no prompts.</p>
      <div class="fxrail-gal">
        <NuxtLink
          v-for="e in fx"
          :key="e.code"
          class="fxrail-card"
          :to="e.href"
        >
          <span class="bg" :style="{ backgroundImage: 'url(' + (e.gif || e.thumb) + ')', backgroundSize: 'cover', backgroundPosition: 'center' }"></span>
          <span class="grain"></span>
          <span class="play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z" /></svg></span>
          <span class="nm">{{ e.title }}</span>
        </NuxtLink>
      </div>
      <NuxtLink class="btn btn-primary" :to="EFFECTS_URL">Try AI Effects</NuxtLink>
      <div class="madeby">Made by SharkFoto AI</div>
    </div>
  </div>
</template>
